import { render, staticRenderFns } from "./BaseTaskView.vue?vue&type=template&id=44b3d0e0&scoped=true"
import script from "./BaseTaskView.vue?vue&type=script&lang=js"
export * from "./BaseTaskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3d0e0",
  null
  
)

export default component.exports